import { createContext, useContext, useState, useCallback, useRef } from 'react';

const DiveContext = createContext(null);

/**
 * DiveProvider — gerencia o ciclo de vida da animação cinematográfica de mergulho.
 *
 * Fases:
 *   idle    → overlay invisível
 *   diving  → GSAP timeline ativa (6 fases, 1.6s total)
 *
 * API:
 *   triggerDive(onCovered) → inicia a animação. onCovered é chamado no impacto (~0.75s)
 *                            — ideal para chamar navigate() nesse momento.
 */
export function DiveProvider({ children }) {
  const [phase, setPhase] = useState('idle');
  const callbackRef = useRef(null);

  const triggerDive = useCallback((onCovered) => {
    callbackRef.current = onCovered || null;
    setPhase('diving');
  }, []);

  /** Chamado pelo DiveOverlay no momento do impacto (fase 3) */
  const notifyCovered = useCallback(() => {
    callbackRef.current?.();
    callbackRef.current = null;
  }, []);

  /** Chamado pelo DiveOverlay quando a timeline completa */
  const notifyDone = useCallback(() => {
    setPhase('idle');
  }, []);

  return (
    <DiveContext.Provider value={{ phase, triggerDive, notifyCovered, notifyDone }}>
      {children}
    </DiveContext.Provider>
  );
}

export const useDive = () => useContext(DiveContext);
